import React from 'react';
import { ArrowRight, FileSpreadsheet, FileText } from 'lucide-react';
import { hero } from '../data/mock';

const Hero = () => {
  return (
    <section 
      className="min-h-screen flex items-center justify-center relative pt-28 pb-16 px-4 md:px-6"
      style={{ background: 'var(--gradient-hero)' }}
    >
      <div className="max-w-6xl mx-auto w-full">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Content */}
          <div className="text-center lg:text-left">
            <h1 className="heading-1 mb-6">
              {hero.headline}
            </h1>
            <p className="body-large mb-8" style={{ color: 'var(--text-secondary)' }}>
              {hero.subheadline}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <a
                href={hero.primaryCta.url}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary gap-2"
              >
                {hero.primaryCta.text}
                <ArrowRight size={18} />
              </a>
              <a
                href={hero.secondaryCta.href}
                className="btn-secondary gap-2"
              >
                {hero.secondaryCta.text}
              </a>
            </div>
          </div>

          {/* Illustration - PDF to Excel transformation */}
          <div className="relative">
            <div className="bg-white rounded-2xl shadow-xl border border-black/10 p-6 md:p-8">
              <div className="flex items-center justify-between gap-4">
                {/* PDF Document */}
                <div className="flex-1 bg-red-50 rounded-xl p-4 md:p-6 border border-red-100">
                  <div className="flex items-center gap-2 mb-4">
                    <FileText className="text-red-500" size={24} />
                    <span className="font-semibold text-sm" style={{ color: 'var(--text-primary)' }}>PDF</span>
                  </div>
                  <div className="space-y-2">
                    <div className="h-2 bg-red-200 rounded-full w-full"></div>
                    <div className="h-2 bg-red-200 rounded-full w-4/5"></div>
                    <div className="h-2 bg-red-200 rounded-full w-full"></div>
                    <div className="grid grid-cols-3 gap-1 mt-4">
                      <div className="h-6 bg-red-100 rounded"></div>
                      <div className="h-6 bg-red-100 rounded"></div>
                      <div className="h-6 bg-red-100 rounded"></div>
                      <div className="h-6 bg-red-100 rounded"></div>
                      <div className="h-6 bg-red-100 rounded"></div>
                      <div className="h-6 bg-red-100 rounded"></div>
                    </div>
                  </div>
                </div>

                {/* Arrow Animation */}
                <div className="flex flex-col items-center gap-1 px-2">
                  <div className="w-8 h-8 rounded-full flex items-center justify-center" style={{ background: 'var(--gradient-button)' }}>
                    <ArrowRight className="text-white" size={16} />
                  </div>
                  <span className="text-xs font-medium" style={{ color: 'var(--accent-text)' }}>Extract</span>
                </div>

                {/* Excel Document */}
                <div className="flex-1 bg-green-50 rounded-xl p-4 md:p-6 border border-green-100">
                  <div className="flex items-center gap-2 mb-4">
                    <FileSpreadsheet className="text-green-600" size={24} />
                    <span className="font-semibold text-sm" style={{ color: 'var(--text-primary)' }}>Excel</span>
                  </div>
                  <div className="space-y-1">
                    <div className="grid grid-cols-3 gap-1">
                      <div className="h-5 bg-green-200 rounded text-xs flex items-center justify-center font-medium text-green-700">A</div>
                      <div className="h-5 bg-green-200 rounded text-xs flex items-center justify-center font-medium text-green-700">B</div>
                      <div className="h-5 bg-green-200 rounded text-xs flex items-center justify-center font-medium text-green-700">C</div>
                    </div>
                    <div className="grid grid-cols-3 gap-1">
                      <div className="h-5 bg-green-100 rounded"></div>
                      <div className="h-5 bg-green-100 rounded"></div>
                      <div className="h-5 bg-green-100 rounded"></div>
                    </div>
                    <div className="grid grid-cols-3 gap-1">
                      <div className="h-5 bg-green-100 rounded"></div>
                      <div className="h-5 bg-green-100 rounded"></div>
                      <div className="h-5 bg-green-100 rounded"></div>
                    </div>
                    <div className="grid grid-cols-3 gap-1">
                      <div className="h-5 bg-green-100 rounded"></div>
                      <div className="h-5 bg-green-100 rounded"></div>
                      <div className="h-5 bg-green-100 rounded"></div>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Status Bar */}
              <div className="mt-6 flex items-center justify-center gap-2 p-3 rounded-lg" style={{ background: 'var(--accent-wash)' }}>
                <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>
                <span className="text-sm font-medium" style={{ color: 'var(--accent-text)' }}>
                  Automatic data extraction in seconds
                </span>
              </div>
            </div>

            {/* Decorative elements */}
            <div className="absolute -z-10 top-4 -right-4 w-full h-full bg-gradient-to-br from-green-200/40 to-yellow-200/40 rounded-2xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
